<template>

  <div class="page_container">
      <div class="get_yinbi_item_container">
        <div class="get_yinbi_item" @click="toFenXiangGuan">
          <img :src="require('@/assets/share.png')" class="get_yinbi_item_img" />
          <div class="get_yinbi_item_text_a">分享官</div>
          <div class="get_yinbi_item_text_b">分享返硬币</div>
          <div class="get_yinbi_item_text_c">查看</div>
        </div>

        <div class="get_yinbi_item" @click="toPingLunHuiKui">
          <img :src="require('@/assets/comment.png')" class="get_yinbi_item_img" />
          <div class="get_yinbi_item_text_a">评论回馈</div>
          <div class="get_yinbi_item_text_b">评论返硬币</div>
          <div class="get_yinbi_item_text_c">查看</div>
        </div>

      </div>


      <div class="get_yingbi_intro">
        <div class="get_yingbi_intro_item">

          <div class="get_yingbi_intro_item_title">硬币是什么？</div>
          <div class="get_yingbi_intro_item_main_body">硬币是净信背单词内通行的虚拟币。</div>

        </div>


        <div class="get_yingbi_intro_item">

        <div class="get_yingbi_intro_item_title">硬币有什么作用？</div>
        <div class="get_yingbi_intro_item_main_body">硬币可以用来开通pdf导出、云词库及未来推出的功能，也可以用来开通终身大会员。</div>

        </div>

        <div class="get_yingbi_intro_item">

        <div class="get_yingbi_intro_item_title">如何获取硬币？</div>
        <div class="get_yingbi_intro_item_main_body">可以通过签到、参与官方活动的方式来获取硬币。</div>

        </div>


        <div class="get_yingbi_intro_item">

        <div class="get_yinbi_item_text_d">每日签到奖励策略</div>
        <div class="get_yingbi_intro_item_main_body">1. 每日签到奖励10个硬币</div>
        <div class="get_yingbi_intro_item_main_body">2. 连续签到7天，额外奖励35个硬币</div>
        <div class="get_yingbi_intro_item_main_body">2. 连续签到30天，额外奖励150个硬币</div>
        <div class="get_yingbi_intro_item_main_body">2. 连续签到90天，额外奖励450个硬币</div>
        <div class="get_yingbi_intro_item_main_body">2. 连续签到180天，额外奖励900个硬币</div>

        </div>

        
        
      </div>
    

  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >


import { useRouter } from 'vue-router';

  const router = useRouter();

  function toFenXiangGuan() {
    // router.push({ name: 'FenXiangGuan' });
    const url = router.resolve({ name: 'FenXiangGuan' }).href;
    window.location.href = url;
  }

  function toPingLunHuiKui() {
    // router.push({ name: 'PingLunHuiKui' });
    const url = router.resolve({ name: 'PingLunHuiKui' }).href;
    
    window.location.href = url;
  }
 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
    
  }

  .get_yinbi_item_container{
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    
  }

  .get_yinbi_item{
    display: flex;
    flex: 1;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    margin: 0.1rem 0.2rem;

    background: #ededed;
    border-radius: 0.3rem;
    
  }

  .get_yinbi_item_img{
    width: 30%;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    
  }

  .get_yinbi_item_text_a{
    font-size: 0.5rem;
    margin-bottom: 0.1rem;
    
  }

  .get_yinbi_item_text_b{
    font-size: 0.3rem;
    color: #848488;
    
  }

  .get_yinbi_item_text_c{
    font-size: 0.3rem;
    color: white;
    margin-top: 0.3rem;
    padding: 0.1rem 0.5rem;
    background: #0C84FF;
    border-radius: 0.3rem;
    margin-bottom: 0.3rem;
  }

  .get_yinbi_item_text_d{
    font-size: 0.4rem;
    color: white;
    margin-top: 0.2rem;
    padding: 0.2rem 0.8rem;
    background: #0C84FF;
    border-radius: 0.3rem;
    margin-bottom: 0.3rem;
  }

  .get_yingbi_intro{
    display: flex;
    flex-direction: column;
    
    justify-content: left;

    margin-top: 0.5rem;
  }


  .get_yingbi_intro_item{
    display: flex;
    flex-direction: column;

    margin-bottom: 0.5rem;
    
    
    margin-left: 0.3rem;
    
  }

    
    
  .get_yingbi_intro_item_title{
    font-size: 0.4rem;
    
    margin-bottom: 0.1rem;
    color: #000000;
    text-align: left;
    
  }
  .get_yingbi_intro_item_main_body{
    font-size: 0.4rem;
    color:#848488;
    
    
    text-align: left;
  }


 
  






  </style>